export default "__VITE_ASSET__CE5CpiRB__"